import { buildOrganizationUrl, normalizePathname } from "@/shared/lib/branch/branch-admin-routing"

/** Branch Details console tabs (parish-admin, read-only view of one branch). */
export enum BranchDetailTab {
  Overview = "overview",
  Members = "members",
  Ministers = "ministers",
  Departments = "departments",
  Team = "team",
  Finance = "finance",
  Settings = "settings",
}

export const BRANCH_DETAIL_TABS: BranchDetailTab[] = [
  BranchDetailTab.Overview,
  BranchDetailTab.Members,
  BranchDetailTab.Ministers,
  BranchDetailTab.Departments,
  BranchDetailTab.Team,
  BranchDetailTab.Finance,
  BranchDetailTab.Settings,
]

/**
 * URL for a Branch Details tab. Branch Details belongs to the Organization console, never to the active
 * normal branch or Settings. Keeping it branchless prevents a reserved Organization segment from leaking
 * into the `:branchSlug` slot.
 */
export function buildBranchDetailTabHref(
  branchId: string,
  tab: BranchDetailTab,
  workspaceSlug?: string | null,
): string {
  return buildOrganizationUrl(workspaceSlug, `/branches/${branchId}/${tab}`)
}

/** Read the active Branch Details tab from the pathname (defaults to Overview). */
export function parseBranchDetailTabFromPathname(pathname: string): BranchDetailTab {
  const path = normalizePathname(pathname)
  const match = path.match(/\/branches\/[^/]+\/([^/?#]+)/)
  const candidate = match?.[1]
  const found = BRANCH_DETAIL_TABS.find((tab) => tab === candidate)
  return found ?? BranchDetailTab.Overview
}
